import './boxInput.scss';

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { toast } from 'react-toastify';

import { dispatch } from '../../../utils/generalUtils';

export interface IBoxInputProps {
    id: string;
    type: string;
    labelArray: string[];
    onClick: (index) => void;
    activeIndexes: number[];
    activeLabels?: string[];
    label: string;
    model: string;
    limitSelectionTo?: number;
}

export interface IBoxInputState {
    activeIndexes: number[];
}

export class BoxInputImpl extends React.Component<IBoxInputProps, IBoxInputState> {
    constructor(props: IBoxInputProps) {
        super(props);
        this.state = { activeIndexes: props.activeIndexes || [] };
    }

    handleClick = (index) => {
        const { model, labelArray, limitSelectionTo } = this.props;
        const { activeIndexes } = this.state;
        if (limitSelectionTo && (activeIndexes.length === limitSelectionTo && activeIndexes.indexOf(index) <= 0)) {
            toast.error(`Maximum of 5 Outfall can be selected for a plant.`, {
                position: toast.POSITION.TOP_RIGHT,
                className: 'failed-toast'
            });
            return;
        }
        if (activeIndexes.indexOf(index) > -1) {
            this.setState({
                activeIndexes: activeIndexes.filter(val => val !== index)
            });
            dispatch(actions.remove(model, activeIndexes.indexOf(index)));
        } else {
            const newArray = activeIndexes;
            newArray.push(index);
            this.setState({
                activeIndexes: newArray
            });
            dispatch(actions.push(model, labelArray[index].replace(/\s/g, '')));
        }
        if (this.props.onClick) {
            this.props.onClick(index);
        }
    }

    render() {
        return (
            <Row className="box-input-container" >
                <Col className="box-label" sm={12} xs={12} >{this.props.label}:</Col>
                {this.props.labelArray.map((boxLabel, index) => {
                    return <Col
                        key={index}
                        sm={12}
                        xs={12}
                        onClick={() => this.handleClick(index)}
                        className={`box-input
                      ${this.state.activeIndexes.indexOf(index) > -1 ? 'active-box' : 'inactive-box'}`} >
                        {boxLabel}
                        <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                    </Col>;
                })
                }
            </Row >
        );
    }

}

export function mapStateToProps() {
    return {
    };
}
export const BoxInput = connect<{}, {}, IBoxInputProps>(mapStateToProps)(BoxInputImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/BoxInput.tsx